import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-abg-site-sidebar',
  templateUrl: './abg-site-sidebar.component.html',
  styleUrls: ['./abg-site-sidebar.component.scss']
})
export class AbgSiteSidebarComponent implements OnInit {

  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();
  selected: string;
  queryParams: {};
  isInitialLoad: boolean = false;
  activeRadioList: boolean[] = [];
  dashboardOptions = {'Weather Forecast': 'weatherforecast','Nowcast' : 'nowcast','Seamless Rainfall' : 'seamlessrf'}
  dashboardType = {'Rainfall' : 'RAINFALL','Temperature' : 'TEMPERATURE','Windspeed' : 'WIND','Humidity' : 'HUMIDITY'}
  selectedDashboard:any
  selectedForecastType:any

  constructor(private route: ActivatedRoute, private gisUtils: UtilsService, private router: Router) {
    this.selected = this.router.url.split("/")[2]
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams = params[param];
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.isInitialLoad = true
        this.selectedDashboard = this.queryParams['dashboardName']
        this.selectedForecastType = this.queryParams['forecastType']
        this.requestSelectedFilterParams()
      }
    })
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    // if (!this.isInitialLoad) {
    //   currentUrlParams = this.selectedParams;
    // }
    currentUrlParams['component'] = 'ABGSITE';
    currentUrlParams['src'] = 'IMD_GRID'
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      this.gisUtils.selectedParams.next(currentUrlParams);
      this.isInitialLoad = false
    }
  }

  onDashboardChange() {
    let options = { ...this.queryParams }
    options['dashboardName'] = this.selectedDashboard
    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    })
  }

  onForecastTypeChange() {
    let options = { ...this.queryParams }
    options['forecastType'] = this.selectedForecastType
    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    })
  }

}
